// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Survey$ReactHooksTemplate = require("../survey.res.js");
var SurveyLanguage$ReactHooksTemplate = require("../surveyLanguage.res.js");
var SurveyPreviewHtmlRenderer$ReactHooksTemplate = require("../SurveyPreviewHtmlRenderer.res.js");

function builderPageToLivePage(survey, builderPage, templates) {
  if (typeof builderPage !== "object") {
    return ;
  }
  switch (builderPage.TAG) {
    case "Welcome" :
        return {
                TAG: "Welcome",
                _0: builderPage._0
              };
    case "QuestionPage" :
        var question = builderPage._1;
        if (question !== undefined) {
          return {
                  TAG: "QuestionPage",
                  _0: templates,
                  _1: {
                    TAG: "SingleQuestion",
                    _0: question
                  },
                  _2: builderPage._2
                };
        }
        var thankYou = Belt_List.head(Survey$ReactHooksTemplate.thankYouList(survey));
        if (thankYou !== undefined) {
          return {
                  TAG: "ThankYou",
                  _0: Caml_option.some(Caml_option.valFromOption(thankYou))
                };
        } else {
          return ;
        }
    case "ThankYou" :
        return {
                TAG: "ThankYou",
                _0: builderPage._0
              };
    
  }
}

function SurveyBuilderLivePreview(props) {
  var onLanguageChange = props.onLanguageChange;
  var surveyLanguages = props.surveyLanguages;
  var survey = props.survey;
  var page = builderPageToLivePage(survey, props.builderPage, props.questionTemplates);
  var theme = Survey$ReactHooksTemplate.surveyTheme(survey);
  var logo = Survey$ReactHooksTemplate.logo(survey);
  if (page !== undefined) {
    return JsxRuntime.jsx(SurveyPreviewHtmlRenderer$ReactHooksTemplate.make, {
                questions: Survey$ReactHooksTemplate.questions(survey),
                survey: survey,
                page: page,
                logo: logo,
                theme: theme,
                client: props.client,
                onNextButtonClick: (function (param) {
                    
                  }),
                onPrevButtonClick: (function (param) {
                    
                  }),
                handleQuestionPreview: props.onQuestionChange,
                onLanguageChange: (function ($$event) {
                    var languageName = $$event.target.value;
                    var language = Belt_List.getBy(surveyLanguages, (function (lang) {
                            return SurveyLanguage$ReactHooksTemplate.name(lang) === languageName;
                          }));
                    if (language !== undefined) {
                      return Curry._1(onLanguageChange, language);
                    }
                    
                  }),
                handleStart: (function (param) {
                    
                  }),
                type_: "BuilderPhone",
                showPreviousButton: true,
                showNextButton: true,
                languageSelected: props.languageSelected,
                surveyLanguages: surveyLanguages,
                redirectionDelay: Survey$ReactHooksTemplate.redirectionDelay(survey),
                substitutionVariables: {}
              });
  } else {
    return JsxRuntime.jsx("div", {
                children: "Select a survey page to preview",
                className: "sb-live-preview-empty"
              });
  }
}

var make = SurveyBuilderLivePreview;

exports.builderPageToLivePage = builderPageToLivePage;
exports.make = make;
/* react/jsx-runtime Not a pure module */
